import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <p className="text-sm text-foreground-400 font-medium uppercase tracking-wider mb-2">
              Shop by Category
            </p>
            <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
              Browse Spreadsheet
              <br />
              <span className="italic text-primary-500">Categories</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-sm leading-relaxed">
            Explore our curated CSSBuy spreadsheet categories. Each category contains verified product links organized for easy browsing and smarter shopping decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100 rounded-xl overflow-hidden transition-all hover:bg-background-200/70 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} CSSBuy Spreadsheet`}
                  title={`${cat.name} Spreadsheet List`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-800 rounded-full mb-2">
                  {cat.name}
                </span>
                <p className="text-sm text-foreground-700 group-hover:text-foreground-950 transition-colors">
                  Browse {cat.name.toLowerCase()} spreadsheets &mdash; updated daily with verified product links
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}